import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import swal from "sweetalert";
import Header from "../../layout/Header";
import Paginated from "../Report/Paginated";
import { getCustomer } from "../../../actions/customer";
import {
    customerView,
    transactionRegistration,
    updateCustomerReceiptData,
    getCustomerReceiptData,
    transactionRedeem,
    fileUpload,
    getVoucherTemplateByMerchantCode,
} from "../campaigns/services";
import { getDate } from "../../../utils/helper";
import { sendWhatsAppMsg, transactionRefund, voucherPurchase } from "../../../actions/auth";
import { eng_voucher } from "../../../Image/Index";
import { decrypt } from "../../../utils/encodingdecoding";
import { novoNordiskMerchantId } from "../../../utils";

const downloadImage = (e, url) => {
    e.preventDefault();
    e.stopPropagation();
    const link = document.createElement("a");
    link.href = url;
    link.download = url.split("/").pop() || "image";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const Kyc = ({ getCustomer, Customer }) => {
    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const [kycList, setKycList] = useState([]);
    const [cusData, setCusData] = useState([]);
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetch = async () => {
            setLoader(true);
            const tempToken = JSON.parse(localStorage.getItem("token_gen"))?.access_token;
            const id = localStorage.getItem("Id");

            try {
                const [kycData, customerData] = await Promise.all([
                    getCustomerReceiptData(tempToken, id),
                    getCustomer(tempToken, id, 1, 10000),
                ]);
                setKycList(kycData?.data?.reverse());
                setCusData(customerData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoader(false);
            }
        };

        fetch();
    }, [getCustomer]);

    const getKYCDetails = async () => {
        setLoader(true);
        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const res = await getCustomerReceiptData(tempToken?.access_token);
        if (res.message === "Success") {
            setKycList(res?.data?.reverse());
        }
        setLoader(false);
    };

    useEffect(() => {
        setCusData(Customer?.data);
    }, [Customer]);

    useEffect(() => {
        if (kycList?.length && cusData?.data?.data?.length) {
            const tempData = kycList.map((ele) => {
                const customer = cusData.data.data.find(
                    (cus) => cus.customerData.customercode === ele.customercode
                );

                return {
                    ...ele,
                    customername: customer?.customerData?.name || "-",
                    action: ele,
                    date: getDate(ele.createdAt, "MM-DD-YYYY"),
                    createdAt: ele.createdAt,
                    batchID: ele.receiptData?.[0]?.batchID || "-",
                };
            });

            setData(tempData.reverse());
        }
    }, [kycList, cusData]);

    const generateVoucherCanvasImage = ({ voucherCode, benefitName }) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = eng_voucher
            img.crossOrigin = "Anonymous";

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);

                ctx.fillStyle = "#000000";
                ctx.textAlign = "left";
                ctx.textBaseline = "middle";
                let fontSize = Math.round(canvas.width * 0.018);
                ctx.font = `500 ${fontSize}px Poppins, Inter, Segoe UI, Arial, sans-serif`;

                const maxTextWidth = canvas.width * 0.32;
                let textWidth = ctx.measureText(voucherCode).width;
                while (textWidth > maxTextWidth && fontSize > 12) {
                    fontSize -= 1;
                    ctx.font = `500 ${fontSize}px Poppins, Inter, Segoe UI, Arial, sans-serif`;
                    textWidth = ctx.measureText(voucherCode).width;
                }
                const textX = canvas.width * 0.207;
                const textY = canvas.height * 0.732;

                ctx.fillText(voucherCode, textX, textY);
                const circleRadius = Math.round(canvas.width * 0.0065);

                const checkX = canvas.width * 0.961;
                const checkY = canvas.width * 0.936;
                const checkZ = canvas.width * 0.911;

                const yLevel = canvas.height * 0.74;

                const drawGreenCircle = (x, y) => {
                    ctx.beginPath();
                    ctx.arc(x, y, circleRadius, 0, Math.PI * 2);
                    ctx.fillStyle = "#4CAF50";
                    ctx.fill();
                    ctx.lineWidth = 1.8;
                    ctx.strokeStyle = "#ffffff";
                    ctx.stroke();
                    ctx.closePath();
                };

                if (benefitName === "CBT Consultation") {
                    drawGreenCircle(checkZ, yLevel);
                }
                if (benefitName === "Nutritionist Consultation") {
                    drawGreenCircle(checkY, yLevel);
                }
                if (benefitName === "Diet Meal Plan" || benefitName === "Meal Plan") {
                    drawGreenCircle(checkX, yLevel);
                }
                canvas.toBlob(
                    (blob) => {
                        if (!blob) return reject(new Error("canvas.toBlob failed"));
                        const file = new File([blob], "voucher.png", { type: "image/png" });
                        resolve(file);
                    },
                    "image/png",
                    0.94
                );
            };

            img.onerror = () => reject(new Error("Failed to load background image: /eng_voucher.jpg"));
        });
    };

    const fetchTemplates = async () => {
        try {
            const token = JSON.parse(localStorage.getItem("token_gen"));
            if (!token?.access_token) return null;

            const rewards = await getVoucherTemplateByMerchantCode(token.access_token);
            const allTemplates = rewards?.data || [];

            const activeTemplates = allTemplates.filter(
                t => t.isActive !== false
            );

            return activeTemplates?.[0]?.code || null;

        } catch (err) {
            console.error("Failed to load voucher templates:", err);
            return null;
        }
    };

    const updateKYCDetails = async (token, body) => {
        const res = await updateCustomerReceiptData(token, body);
        if (res.message === "Success") {
            await getKYCDetails();

            swal({
                position: "center",
                icon: "success",
                title: "Request processed successfully.",
                showConfirmButton: false,
                timer: 2000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: res.message,
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };

    const handleNovoNordiskSubmit = async (receipt, transactionReg, custRes, body) => {
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const redeemBody = {
            customer: { customercode: receipt?.customercode },
            redeemDetail: {
                walletType: "point",
                values: transactionReg?.data?.[0]?.earnedValue || 0,
                transactionType: "redeem",
                transactionDate: new Date().toISOString().split("T")[0],
            },
        };
        const redeemRes = await transactionRedeem(token.access_token, JSON.stringify(redeemBody));
        if (redeemRes?.message === "Request processed successfully.") {
            const templateCode = await fetchTemplates();
            const voucherBody = {
                voucherTemplateCode: templateCode,
                merchantId: novoNordiskMerchantId,
                customerCode: receipt?.customercode,
                value: transactionReg?.data?.[0]?.earnedValue || 0,
                amount: transactionReg?.data?.[0]?.earnedValue || 0,
                RedeemTransactionId: redeemRes?.data?.currentTransactionId,
            };
            const purchaseRes = await voucherPurchase(token.access_token, voucherBody);
            if (purchaseRes?.data?.code) {
                const voucherCode = purchaseRes.data.code;
                const voucherFile = await generateVoucherCanvasImage({
                    voucherCode,
                    benefitName: purchaseRes.data.name,
                });
                const fileRes = await fileUpload(token.access_token, voucherFile, {});
                const uploadedImageUrl = fileRes?.data?.blobFilePath;
                const whatsappBody = {
                    integrated_number: "919717154514",
                    content_type: "template",
                    payload: {
                        messaging_product: "whatsapp",
                        type: "template",
                        template: {
                            name: "novo_nordisk_voucher",
                            language: {
                                code: "en",
                                policy: "deterministic",
                            },
                            namespace: "f93dcba9_2aaa_45ad_9ec5_fc410f911651",
                            to_and_components: [
                                {
                                    to: [`${custRes?.customer?.countryCode}${custRes?.customer?.mobile}`],
                                    components: {
                                        header_1: {
                                            type: "image",
                                            value: uploadedImageUrl
                                        },
                                        body_1: { type: "text", value: custRes?.customer?.name },

                                    },
                                },
                            ],
                        },
                    },
                };

                await sendWhatsAppMsg(whatsappBody);
                await updateKYCDetails(token?.access_token, body);
            } else {
                swal({
                    position: "center",
                    icon: "error",
                    title: "Redemption failed. Please try later",
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        } else {
            await transactionRefund(token.access_token, JSON.stringify({
                customer: { customercode: receipt?.customercode },
                transactionId: redeemRes?.data?.currentTransactionId,
                transactionAmount: 0,
                transactionDate: new Date().toISOString().split("T")[0],
                transactionType: "refund"
            }));

            swal({
                position: "center",
                icon: "error",
                title: "Redemption failed, Please try later",
                showConfirmButton: false,
                timer: 2000,
            });
        }
    }

    const onSubmit = async (receipt, status) => {
        const { updatedAt, _attachments, action, date, _etag, _rid, _self, _ts, ...rest } = receipt;
        setLoader(true);
        const body = {
            ...rest,
            other1: {
                ...rest.other1,
                status: status,
            },
        };
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const id = localStorage.getItem("Id")
        const custRes = await customerView(token?.access_token, receipt?.customercode);

        const transBody = {
            amount: 200,
            mobile: custRes?.customer?.mobile,
            schemacode: "TSC002026",
            productName: "wegovy",
            batchID: receipt?.receiptData?.[0]?.batchID
        };


        if (status === 1) {
            const transactionReg = await transactionRegistration(
                token?.access_token,
                JSON.stringify(transBody)
            );
            if (transactionReg?.message === "Request processed successfully.") {
                if (decrypt(id) === (novoNordiskMerchantId)) {
                    await handleNovoNordiskSubmit(receipt, transactionReg, custRes, body)
                } else {
                    await updateKYCDetails(token?.access_token, body);
                }

            } else {
                swal({
                    position: "center",
                    icon: "error",
                    title: transactionReg.message,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        } else {
            await updateKYCDetails(token?.access_token, body);
        }
        setLoader(false);
    };

    const COLUMNS = [
        {
            Header: "Date",
            Footer: "Date",
            accessor: "date",
            disableFilters: true,
            sticky: "left",
        },
        {
            Header: "Customer Name",
            Footer: "Customer Name",
            accessor: "customername",
        },
        {
            Header: "Batch ID",
            Footer: "Batch ID",
            accessor: "batchID",
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: "action",
            Cell: ({ value, row }) => {
                const receipt = row.original;
                return (
                    <div className="d-flex justify-content-between align-items-center">
                        {value?.other1?.status === 0 ? (
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    className="btn btn-link p-0 me-2 text-success"
                                    onClick={() => onSubmit(receipt, 1)}
                                >
                                    Approved
                                </button>
                                <button
                                    className="btn btn-link p-0 text-danger"
                                    onClick={() => onSubmit(receipt, 2)}
                                >
                                    Rejected
                                </button>

                            </div>
                        ) : value?.other1?.status === 1 ? (
                            <button className="btn btn-link p-0 text-success" disabled>
                                Approved
                            </button>
                        ) : value?.other1?.status === 2 ? (
                            <button className="btn btn-link p-0 text-danger" disabled>
                                Rejected
                            </button>
                        ) : null}
                        <div className="ml-2">
                            <Link
                                to={`/customer-view/${value?.customercode}`}
                                state={{
                                    customerCode: value?.customercode,
                                }}
                                className='edit_btn'
                                csvalue='View Details'>
                                <i className='fa-solid fa-eye'></i>View Details
                            </Link>
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div><div></div><div></div><div></div>
                        <div></div><div></div><div></div><div></div>
                    </div>
                </div>
            )}

            <Header name={"Verification & Approvals"} />

            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Verification & Approvals</h4>
                            </div>
                        </div>

                        <div className="dashboard__body">
                            <Paginated data={data || []} columns={COLUMNS} setData={setData} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    Customer: state.Customer,
});

const mapDispatchToProps = {
    getCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(Kyc);
